import AjaxRequest from './AjaxRequest';

export default class Photo
{
    favorite(film, frame, data) {
        return new AjaxRequest().post(`photos/${film}/${frame}/favorite`, data);
    }

    unfavorite(film, frame, data) {
        return new AjaxRequest().post(`photos/${film}/${frame}/unfavorite`, data);
    }

    favorites(data) {
        return new AjaxRequest().post(`photos/favorites`, data);
    }

    favoriteImages(data) {
        return new AjaxRequest().post(`photos/favorites/images`, data);
    }

    getAsSheet(data) {
        return new AjaxRequest().post(`photos/sheet`, data);
    }

    getImage(film, frame, data) {
        return new AjaxRequest().post(`photos/${film}/${frame}`, data);
    }
}
